<template>
    <div>
        <div v-if="errorStatus" class="alert alert-danger my-3" role="alert" v-html="errorStatus">
        
        </div>

        

        <SignUp v-else-if="showSignup" completionPath="" showCancel="true" @cancel="showSignup=false" @signupcomplete="showSignup=false"></SignUp>
       
        <div v-else >
          <!--<transition name="fade" mode="out-in">-->
            <div >
              <template v-if="!hasSession || !showCurrentSubs">
                <!--
                <div  v-if="isContainerInited" class="bg-primary mb-2 row border rounded py-1 my-1 mx-md-5">
                    <div class="col-12 col-md-4 d-flex flex-column align-items-center justify-content-center mb-2 mb-md-0">
                        <button class="btn btn-light btn-lg  position-relative" @click="signupFree()"> 
                          {{ $t('signupforfree') }}
                        </button>
                        
                    </div>

                    <div class="col-12 col-md-8 d-flex align-items-center justify-content-center text-light">
                        {{ $t('messages.getStartedFree') }}
                    </div>
                </div>
                -->
              </template>




              <div v-else-if="noAdminPermissions"  class="bg-light mb-2 row border rounded py-1 my-1 mx-md-5">
                <h6>{{ $t('messages.noAdminPermissions') }}</h6>
                <div class="d-flex align-items-center">
                    {{ $t('messages.contactAdmin') }}
                </div>
              </div>
              
              <div v-else-if="!hasPrimarySubscription && !hasActivePlans" class="mb-2">
                <div class="p-2 rounded-2 border border-dark-subtle">
                    <div class="d-flex flex-wrap w-100 align-items-center justify-content-between">
                        <div class="d-flex flex-column mb-2">
                            <div class="fw-bold mb-1">{{ $t('messages.yourCurrentSubscriptions') }}</div>
                            <div  class="opacity-60 fs-sm">
                                {{  $t('messages.freePlan') }}
                            </div>
                        </div>
                      
                    </div>
                </div>
              </div>

              <div v-else-if="!hasPrimarySubscription && hasActivePlans" class="mb-2">
                <div class="p-2 rounded-2 border border-dark-subtle">
                    <div class="d-flex flex-wrap w-100 align-items-center justify-content-between">
                        <div class="d-flex flex-column mb-2">
                            <div class="fw-bold mb-1">{{ $t('messages.yourCurrentSubscriptions') }}</div>
                            <div class="opacity-60 fs-sm">
                                {{ activePlans.join(', ') }}
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              



              <div v-else  class="mb-3"> 
                <h4>{{ $t('messages.yourCurrentSubscriptions') }}</h4>

                <div v-if="hasPrimarySubscription" class="mb-2">
                        <div v-for="sub in primarySubscriptions" :key="sub.id" class="p-2 rounded-2 border border-dark-subtle">
                            <div class="d-flex flex-wrap w-100 align-items-center justify-content-between">
                                <div class="d-flex flex-column mb-2">
                                    <div class="fw-bold mb-1">{{ getSubLabel(sub) }}</div>
                                    <div v-if="isSubMeteredNoPaymentMethod(sub)" class="opacity-60 fs-sm">
                                        {{ $t('messages.addPaymentMethod') }}
                                    </div>
                                    <div  v-if="!isSubActive(sub)" class="text-danger">
                                        <i class="bi bi-exclamation-triangle-fill me-2"></i> {{ getSubStatus(sub) }}
                                    </div>
                                </div>
                                <a v-if="canModifySub(sub)" class="btn btn-primary btn-sm" @click="createportalsession('subscription_cancel',sub.id)">{{ $t('messages.cancel') }}</a>
                            </div>
                            <div class="d-flex align-items-center justify-content-between">
                                <div v-if="getSubCancelAtPeriodEnd(sub)">{{ $t('messages.cancelsOn') }} {{ getSubRenewalDate(sub) }}</div>
                                <div v-else-if="sub.endsAt">{{ $t('messages.ends') }} {{ getSubEndsDate(sub) }}</div>
                                <div v-else>{{ $t('messages.renewsOn') }} {{ getSubRenewalDate(sub) }}</div>

                                <div v-if="isDirectBilled(sub)" class="fs-sm">
                                    {{ $t('messages.directBilling') }}
                                </div>
                                <div v-if="sub.schedule" class="fs-sm">
                                    {{ $t('messages.contactSupportForScheduled') }}
                                </div>
                            </div>
                        </div>
                    </div>

                  <div v-if="hasAddonSubscription" class="mb-2">  
                    <!--<h5>Addon subscription</h5>-->
                    <div v-for="sub in addonSubscriptions" :key="sub.id" class="p-2 rounded-2 border border-dark-subtle">
                      <div class="d-flex flex-wrap w-100 justify-content-between">
                        <div class="fw-bold mb-1">{{getSubLabel(sub)}}</div>
                        <a v-if="canModifySub(sub)" class="btn btn-primary btn-sm" @click="createportalsession('subscription_cancel',sub.id)">{{ $t('messages.cancel') }}</a>
                      </div>
                      <div class="d-flex align-items-center justify-content-between">
                        <div v-if="getSubCancelAtPeriodEnd(sub)" class="">{{ $t('messages.cancelsOn') }} {{getSubRenewalDate(sub)}}</div>
                        <div v-else class="">{{ $t('messages.renews') }} {{getSubRenewalDate(sub)}} </div>

                        <div v-if="isDirectBilled(sub)" class="fs-sm">
                          {{ $t('messages.directBilling') }}
                        </div>
                      </div>
                    </div>
                  </div>


                  <div v-if="hasOtherSubscription" class="mb-2">  
                    <!--<h5>Other subscription</h5>-->
                    <div v-for="sub in otherSubscriptions" :key="sub.id" class="p-2 rounded-2 border border-dark-subtle">
                      <div class="d-flex flex-wrap w-100 justify-content-between">
      
                        <div class="fw-bold mb-1">{{getSubLabel(sub)}}</div>
                        <a v-if="canModifySub(sub)" class="btn btn-primary btn-sm ms-auto" @click="createportalsession('subscription_cancel',sub.id)">{{ $t('messages.cancel') }}</a>
                      </div>
                      <div class="d-flex align-items-center justify-content-between">
                        <div v-if="getSubCancelAtPeriodEnd(sub)" class="">{{ $t('messages.cancelsOn') }} {{getSubRenewalDate(sub)}}</div>
                        <div v-else class="">Renews: {{getSubRenewalDate(sub)}} </div>

                        <div v-if="isDirectBilled(sub)" class="fs-sm">
                          {{ $t('messages.directBilling') }}
                        </div>

                      </div>
                    </div>
                  </div>
              
                      
                  <div v-if="hasScheduledSubscription" class="mb-2">  
                    <h5>{{ $t('messages.scheduledsubcriptions') }}</h5>
                    <div v-for="sub in scheduledSubscriptions" :key="sub.id" class="p-2 rounded-2 border border-dark-subtle">
                      <div v-for="phase in filteredPhases(sub)" :key="phase.id" class="">
                        <div class="d-flex flex-wrap w-100 justify-content-between">
        
                          <div class="fw-bold mb-1">{{getSubLabel(sub)}}</div>
                        
                        </div>
                        <div class="d-flex align-items-center justify-content-between">
                          <div class=""> {{ $t('messages.starts') }} {{getSubStartDate(phase)}} </div>

                          <div  class="fs-sm">
                            {{ $t('messages.scheduledsubcription') }}
                  
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
        <!--</transition>-->
        
        <!-- Sticky controls: jump buttons + billing interval -->
        <div class="sticky-top z-1 shadow-sm">
           <div class="container-fluid bg-primary rounded-2 border-bottom pt-1 pb-3">
           
           
              <h4 class="text-light">{{ $t('messages.primarygoalheader') }}</h4>

              <div class="d-flex flex-wrap align-items-center justify-content-center gap-4">
                <!-- Jump buttons -->
                <button class="btn btn-light shadow-sm rounded-pill fw-semibold px-3 py-1 pricing-chip " @click="scrollToSection('availableprimarysubs')">
                  {{ $t('messages.primaryjump') }}
                </button>
                <button class="btn btn-light shadow-sm rounded-pill fw-semibold px-3 py-1 position-relative pricing-chip " @click="scrollToSection('availableprimaryllxsubs')">
                  <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">{{ $t('messages.newviolator') }}</span>
              
                  {{ $t('messages.llxjump') }}
                </button>
                <button class="d-none d-md-inline btn btn-light shadow-sm rounded-pill fw-semibold px-3 py-1 pricing-chip " @click="scrollToSection('availableaddonsubs')">
                  {{ $t('messages.addjump') }}
                </button>

                <button v-if="!isChild" class="d-none d-md-inline btn btn-light shadow-sm rounded-pill fw-semibold px-3 py-1 pricing-chip" @click="scrollToSection('industrysolutions')">
                  {{ $t('messages.industrydatajump') }}
                </button>
                <!--
                <button v-if="!hasSession || !showCurrentSubs" class="position-absolute top-0 start-90 translate-middle badge rounded-pill bg-danger btn  text-light   px-2 py-1" @click="signupFree()"> 
                  {{ $t('signupforfree') }}
                </button>
-->

                <!-- Billing interval selector -->
                <!--
                <div class="btn-group ms-md-3" role="group" aria-label="Billing interval">
                  <button type="button"
                          class="btn btn-outline-primary"
                          :class="{ active: interval === 'month' }"
                          @click="setInterval('month')">
                    {{ $t('monthly') }}
                  </button>
                  <button type="button"
                          class="btn btn-outline-primary position-relative"
                          :class="{ active: interval === 'year' }"
                          @click="setInterval('year')">
                    {{ $t('annual') }}
                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                      {{ $t('messages.annualviolator') }}
                    </span>
                  </button>
                </div>
                -->
              
            </div>
          </div>
        </div>
 


        <div class="row justify-content-between align-items-center mt-4 mb-2">
          <h3 id="availableprimarysubs" class="mb-0 col-12 col-md-9">{{ $t('messages.availableprimarysubs') }}</h3>
          <div class="btn-group col-12 col-md-3 pe-5" role="group" aria-label="Billing interval">
            <button type="button"
                    class="btn btn-outline-primary btn-sm z-0"
                    :class="{ active: interval === 'month' }"
                    @click="setInterval('month')">
              {{ $t('monthly') }}
            </button>
            <button type="button"
                    class="btn btn-outline-primary btn-sm z-0 position-relative"
                    :class="{ active: interval === 'year' }"
                    @click="setInterval('year')">
              {{ $t('annual') }}
              <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                {{ $t('messages.annualviolator') }}
              </span>
            </button>
          </div>
        </div>
        
          
        <!--
          <ul class="nav nav-tabs justify-content-center border-0" role="tablist">
            <li class="nav-item px-2">
              <button class="btn btn-outline-primary btn-lg pricetoggle" :class="{ active: interval === 'month' }" @click="setInterval('month')">  {{ $t('monthly') }}</button>
            </li>

            <li class="nav-item px-2">
              <button class="btn btn-outline-primary btn-lg pricetoggle position-relative" :class="{ active: interval === 'year' }" @click="setInterval('year')">  {{ $t('annual') }}
                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">{{ $t('messages.annualviolator') }}</span>
              </button>
             
            </li>
          </ul>
          -->

          <div class="tab-content plans mt-4 d-flex flex-column justify-content-center">
           
            <div class="row justify-content-center">
              <div
                v-for="product in filteredPrimaryProducts"
                :key="product.id"
                class="col-sm-6 col-md-4 col-lg-3 mb-4 px-1"
              >
                <div class="card card-active  shadow-sm" >
                  <div class="card-body text-center" :class="[isPriceActiveSub(null, product.prices, currency, interval)? 'border rounded border-primary':'']">
                    
                    <div type="button" v-if="isPriceCancellingSub(null, product.prices, currency, interval)" class="badge rounded-pill bg-danger fs-6">
                      {{ $t('messages.cancelling') }}
                    </div>
                    <div type="button" v-else-if="isPriceActiveSub(null, product.prices, currency, interval)" class="badge rounded-pill bg-danger fs-6">
                      {{ $t('messages.current') }}
                    </div>
                    
                    <div v-else-if="hasSession" class="badge rounded-pill  fs-6">
                      &nbsp;
                    </div>
                    
                    <img class="d-block mx-auto mt-1 mb-1" :src="getIconPath(product)" width="48" height="48" alt="Icon">
                  
                    <h2 class="h5 fw-normal py-1 mb-1">{{ $t(getProductLabel(product.id).name) }}</h2>
                    <div class="d-flex flex-column align-items-center mb-2" >
                      
                      <div class="d-flex flex-row align-items-center">
                        <div class="h3 mb-0">
                          {{ getPriceAmount(product.prices, currency, interval) }}
                        </div>
                        <div class="fs-xs pb-1 pe-1">{{ showCurrency(product.prices, currency, interval)?currency.toUpperCase():"&nbsp;" }}</div>
                        <div v-if="showInterval(product.prices, currency, interval)" class="h5 mb-0">{{ "/"+getPriceInterval(product, currency, interval) }}</div>
                      </div>
                      
                    
                    </div>
                    <div class="fs-xs text-muted" style="height: 40px;">
                      {{ $t(getProductLabel(product.id).description) }}
                    </div>

                    <div class="text-center pt-2 pb-3">
                      <button v-if="isPriceContactUs(product)" class="btn btn-primary btn-sm monthly" @click="contactUs(product)" href="#">{{ $t('messages.contactus') }}</button>
                      <button v-else-if="product.link" class="btn btn-primary btn-sm monthly" @click="openLink(product)" href="#">{{ product.buttonLabel ? $t(product.buttonLabel) : $t('messages.details') }}</button>
                      <button v-else-if="!hasSession" class="btn btn-primary btn-sm monthly" @click="createSessionThenCheckout(getPrice(product.prices, currency, interval) )">{{ $t('messages.chooseplan') }}</button>
                      <button v-else-if="hasScheduledSubscription" class="btn btn-primary btn-sm monthly"  @click="contactSupport(product)" >{{ $t('messages.contactsupport') }}</button>
                      <button v-else-if="isPriceCancellingSub(null, product.prices, currency, interval)" class="btn btn-primary btn-sm monthly"  @click="contactSupport(product)" >{{ $t('messages.contactsupport') }}</button>
                      <button v-else-if="!primarySubscription" class="btn btn-primary btn-sm monthly" @click="createCheckoutSession(getPrice(product.prices, currency, interval) )">{{ $t('messages.chooseplan') }}</button>
                      <button v-else-if="primarySubscription.schedule" class="btn btn-primary btn-sm monthly"  @click="contactSupport(product)" >{{ $t('messages.contactsupport') }}</button>
                      <button v-else-if="isPriceActiveSub( null, product.prices, currency, interval) && canModifySub(primarySubscription)" class="btn btn-primary btn-sm monthly" @click="createportalsession('subscription_cancel',primarySubscription.id)">{{ $t('messages.cancel') }}</button>
                      <button v-else-if="isMeteredToLicensed( primarySubscription, product.prices, currency, interval)" class="btn btn-primary btn-sm monthly" @click="createCheckoutSession(getPrice(product.prices, currency, interval) )">{{ $t('messages.upgrade') }}</button>
                      <button v-else-if="isLicensedToMetered( primarySubscription, product.prices, currency, interval)" @click="contactSupport(product)" class="btn btn-primary btn-sm monthly">{{ $t('messages.contactsupport') }}</button>
                      <button v-else-if="canUpgradeToPrice( primarySubscription, product.prices, currency, interval)" class="btn btn-primary btn-sm monthly" @click="createportalsession('subscription_update_confirm',primarySubscription.id,getPrice(product.prices, currency, interval).id)">{{ $t('messages.upgrade') }}</button>
                      <button v-else-if="canDowngradeToPrice( primarySubscription, product.prices, currency, interval)" class="btn btn-primary btn-sm monthly" @click="createportalsession('subscription_update_confirm',primarySubscription.id,getPrice(product.prices, currency, interval).id)">{{ $t('messages.downgrade') }}</button>
                      <button v-else class="btn btn-primary btn-sm monthly"  @click="contactSupport(product)">{{ $t('messages.contactsupport') }}</button>
                    </div>
                    <template v-if="showFeatures">
                      <div class="border-top border-bottom border-primary text-primary bg-light text-center pt-2 pb-2">
                        <ul class="list-unstyled m-0">
                          <li v-for="(feature, index) in getProductLabel(product.id).marketingFeatures" :key="feature" :class="{ 'fw-bold ': index === 0 }">
                            {{ $t(feature) }}
                          </li>
                        </ul>
                      </div>
                        <ul class="list-unstyled d-block mt-2 mb-0 mx-auto fs-sm" style="max-width:16rem;">
                          <li v-for="feature in (isExpanded(product.id) ? getProductLabel(product.id).features : shortFeatures(getProductLabel(product.id).features))"
                              :key="feature.text"
                              class="d-flex py-0 align-items-center">
                            <span :class="{ 'text-muted': !feature.enabled, 'fw-bold text-primary': feature.highlight }">
                              ✔ {{ $t(feature.text) }}
                            </span>
                          </li>
                        </ul>
                        <div class="mt-1">
                          <button
                            class="btn btn-link btn-sm p-0"
                            :aria-expanded="isExpanded(product.id)"
                            @click="toggleFeatures(product.id)">
                            <span v-if="!isExpanded(product.id)">{{ $t('messages.showAllFeatures') || 'Show all features' }}</span>
                            <span v-else>{{ $t('messages.showLess') || 'Show less' }}</span>
                          </button>
                        </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>

           <div class="row justify-content-between align-items-center mt-4 mb-2">
            <h3 id="availableprimaryllxsubs" class="mb-0 col-12 col-md-9">{{ $t('messages.availableprimaryllxsubs') }}</h3>
            <div class="btn-group col-12 col-md-3 pe-5" role="group" aria-label="Billing interval">
              <button type="button"
                      class="btn btn-outline-primary btn-sm z-0"
                      :class="{ active: interval === 'month' }"
                      @click="setInterval('month')">
                {{ $t('monthly') }}
              </button>
              <button type="button"
                      class="btn btn-outline-primary btn-sm z-0 position-relative"
                      :class="{ active: interval === 'year' }"
                      @click="setInterval('year')">
                {{ $t('annual') }}
                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {{ $t('messages.annualviolator') }}
                </span>
              </button>
            </div>
          </div>
            
            <i18n-t keypath="messages.introllxsubs" tag="p">
              <a href="/resources/documentation/weather-api/timeline-llx-weather-api/" target="_blank" rel="noopener" class="text-primary">
                {{ $t('messages.introllxsubs_prefix') }}
              </a>
            </i18n-t>
            <div class="row justify-content-center mt-3">
              <div
                v-for="product in filteredPrimaryLLxProducts"
                :key="product.id"
                class="col-sm-6 col-md-4 col-lg-3 mb-4 px-1"
              >
                <div class="card card-active  shadow-sm" >
                  <div class="card-body text-center" :class="[isPriceActiveSub(null, product.prices, currency, interval)? 'border rounded border-primary':'']">
                    
                    <div type="button" v-if="isPriceCancellingSub(null, product.prices, currency, interval)" class="badge rounded-pill bg-danger fs-6">
                      {{ $t('messages.cancelling') }}
                    </div>
                    <div type="button" v-else-if="isPriceActiveSub(null, product.prices, currency, interval)" class="badge rounded-pill bg-danger fs-6">
                      {{ $t('messages.current') }}
                    </div>
                    <div v-else-if="hasSession" class="badge rounded-pill fs-6">
                      &nbsp;
                    </div>

                    <img class="d-block mx-auto mt-1 mb-1" :src="getIconPath(product)" width="48" height="48" alt="Icon">
                  
                    <h2 class="h5 fw-normal py-1 mb-1">{{ $t(getProductLabel(product.id).name) }}</h2>
                    <div class="d-flex flex-column align-items-center mb-2" >
                      
                      <div class="d-flex flex-row align-items-center">
                        <div class="h3 mb-0">
                          {{ getPriceAmount(product.prices, currency, interval) }}
                        </div>
                        <div  class="fs-xs pb-1 pe-1">{{ showCurrency(product.prices, currency, interval)?currency.toUpperCase():"&nbsp;" }}</div>
                        <div v-if="showInterval(product.prices, currency, interval)" class="h5 mb-0">{{ "/"+getPriceInterval(product, currency, interval) }}</div>
                      </div>
                      
                    </div>
                    <div class="fs-xs text-muted" style="height: 40px;">
                      {{ $t(getProductLabel(product.id).description) }}
                    </div>

                    <div class="text-center pt-2 pb-3">
                      <button v-if="isPriceContactUs(product)" class="btn btn-primary btn-sm monthly" @click="contactUs(product)" href="#">{{ $t('messages.contactus') }}</button>
                      <button v-else-if="product.link" class="btn btn-primary btn-sm monthly" @click="openLink(product)" href="#">{{ product.buttonLabel ? $t(product.buttonLabel) : $t('messages.details') }}</button>
                      <button v-else-if="!hasSession" class="btn btn-primary btn-sm monthly" @click="createSessionThenCheckout(getPrice(product.prices, currency, interval) )">{{ $t('messages.chooseplan') }}</button>
                      <button v-else-if="hasScheduledSubscription" class="btn btn-primary btn-sm monthly"  @click="contactSupport(product)" >{{ $t('messages.contactsupport') }}</button>
                      <button v-else-if="isPriceCancellingSub(null, product.prices, currency, interval)" class="btn btn-primary btn-sm monthly"  @click="contactSupport(product)" >{{ $t('messages.contactsupport') }}</button>
                      <button v-else-if="!primarySubscription" class="btn btn-primary btn-sm monthly" @click="createCheckoutSession(getPrice(product.prices, currency, interval) )">{{ $t('messages.chooseplan') }}</button>
                      <button v-else-if="primarySubscription.schedule" class="btn btn-primary btn-sm monthly"  @click="contactSupport(product)" >{{ $t('messages.contactsupport') }}</button>
                      <button v-else-if="isPriceActiveSub( null, product.prices, currency, interval) && canModifySub(primarySubscription)" class="btn btn-primary btn-sm monthly" @click="createportalsession('subscription_cancel',primarySubscription.id)">{{ $t('messages.cancel') }}</button>
                      <button v-else-if="isMeteredToLicensed( primarySubscription, product.prices, currency, interval)" class="btn btn-primary btn-sm monthly" @click="createCheckoutSession(getPrice(product.prices, currency, interval) )">{{ $t('messages.upgrade') }}</button>
                      <button v-else-if="isLicensedToMetered( primarySubscription, product.prices, currency, interval)" @click="contactSupport(product)" class="btn btn-primary btn-sm monthly">{{ $t('messages.contactsupport') }}</button>
                      <button v-else-if="canUpgradeToPrice( primarySubscription, product.prices, currency, interval)" class="btn btn-primary btn-sm monthly" @click="createportalsession('subscription_update_confirm',primarySubscription.id,getPrice(product.prices, currency, interval).id)">{{ $t('messages.upgrade') }}</button>
                      <button v-else-if="canDowngradeToPrice( primarySubscription, product.prices, currency, interval)" class="btn btn-primary btn-sm monthly" @click="createportalsession('subscription_update_confirm',primarySubscription.id,getPrice(product.prices, currency, interval).id)">{{ $t('messages.downgrade') }}</button>
                      <button v-else class="btn btn-primary btn-sm monthly"  @click="contactSupport(product)">{{ $t('messages.contactsupport') }}</button>
                    </div>
                    <template v-if="showFeatures">
                      <div class="border-top border-bottom border-primary text-primary bg-light text-center pt-2 pb-2">
                        <ul class="list-unstyled m-0">
                          <li v-for="(feature, index) in getProductLabel(product.id).marketingFeatures" :key="feature" :class="{ 'fw-bold ': index === 0 }">
                            {{ $t(feature) }}
                          </li>
                        </ul>
                      </div>
                                              <ul class="list-unstyled d-block mt-2 mb-0 mx-auto fs-sm" style="max-width:16rem;">
                          <li v-for="feature in (isExpanded(product.id) ? getProductLabel(product.id).features : shortFeatures(getProductLabel(product.id).features))"
                              :key="feature.text"
                              class="d-flex py-0 align-items-center">
                            <span :class="{ 'text-muted': !feature.enabled, 'fw-bold text-primary': feature.highlight }">
                              ✔ {{ $t(feature.text) }}
                            </span>
                          </li>
                        </ul>
                        <div class="mt-1">
                          <button
                            class="btn btn-link btn-sm p-0"
                            :aria-expanded="isExpanded(product.id)"
                            @click="toggleFeatures(product.id)">
                            <span v-if="!isExpanded(product.id)">{{ $t('messages.showAllFeatures') || 'Show all features' }}</span>
                            <span v-else>{{ $t('messages.showLess') || 'Show less' }}</span>
                          </button>
                        </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>

          
          <div class="row justify-content-between align-items-center mt-4 mb-2">
            <h3 id="availableaddonsubs" class="mb-0 col-12 col-md-9">{{ $t('messages.availableaddonsubs') }}</h3>
            <div class="btn-group col-12 col-md-3 pe-5" role="group" aria-label="Billing interval">
              <button type="button"
                      class="btn btn-outline-primary btn-sm z-0" 
                      :class="{ active: interval === 'month' }"
                      @click="setInterval('month')">
                {{ $t('monthly') }}
              </button>
              <button type="button"
                      class="btn btn-outline-primary btn-sm z-0position-relative"
                      :class="{ active: interval === 'year' }"
                      @click="setInterval('year')">
                {{ $t('annual') }}
                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {{ $t('messages.annualviolator') }}
                </span>
              </button>
            </div>
          </div>
          <i18n-t keypath="messages.intoaddonsubs" tag="p">
              
          </i18n-t>
            <div class="row justify-content-center">
              <div
                v-for="product in filteredAddonProducts"
                :key="product.id"
                class="col-sm-6 col-md-4 col-lg-3 mb-4 px-1"
              >
                <div class="card card-active  shadow-sm" >
                  <div class="card-body text-center" :class="[isPriceActiveSub(null, product.prices, currency, interval)? 'border rounded border-primary':'']">

                   
                    <div type="button" v-if="isPriceActiveSub(null, product.prices, currency, interval)" class="badge rounded-pill bg-danger fs-6">
                      {{ $t('messages.current') }}
                    </div>
                    <!--<div v-else class="badge rounded-pill  fs-6">
                      &nbsp;
                    </div>-->

                    <img class="d-block mx-auto mt-1 mb-1" :src="getIconPath(product)" width="48" height="48" alt="Icon">
                  
                    <h2 class="h5 fw-normal py-1 mb-1">{{ $t(getProductLabel(product.id).name) }}</h2>
                    <div class="d-flex flex-column align-items-center mb-2" >
                      
                    <div class="d-flex flex-row align-items-center">
                        <div class="h3 mb-0">
                          {{ getPriceAmount(product.prices, currency, interval) }}
                        </div>
                        <div  class="fs-xs pb-1 pe-1">{{ showCurrency(product.prices, currency, interval)?currency.toUpperCase():"&nbsp;" }}</div>
                        <div v-if="showInterval(product.prices, currency, interval)" class="h5 mb-0">{{ "/"+getPriceInterval(product, currency, interval) }}</div>
                    </div>
                    
                    </div>
                    <div class="fs-xs text-muted" style="height: 40px;">
                      {{ $t(getProductLabel(product.id).description) }}
                    </div>

                    <div class="text-center pt-2 pb-3">
                      <button v-if="isPriceContactUs(product)" class="btn btn-primary btn-sm monthly"  @click="contactUs(product)" href="#">{{ $t('messages.contactus') }}</button>
                      <button v-else-if="product.link" class="btn btn-primary btn-sm monthly" @click="openLink(product)" href="#">{{ $t('messages.details') }}</button>
                      <button v-else-if="!hasSession" class="btn btn-primary btn-sm monthly" @click="createSessionThenCheckout(getPrice(product.prices, currency, interval) )">{{ $t('messages.chooseplan') }}</button>
                      <button v-else-if="!hasPrimarySubscription" class="btn btn-primary btn-sm monthly" disabled="1">{{ $t('messages.noprimary') }}</button>
                      <button v-else-if="isPriceActiveSub(addonSubscriptions, product.prices, currency, interval)" class="btn btn-primary btn-sm monthly" @click="createportalsession('subscription_cancel',isPriceActiveSub(addonSubscriptions, product.prices, currency, interval).id)">{{ $t('messages.cancel') }}</button>
                      <button v-else class="btn btn-primary btn-sm monthly" @click="createCheckoutSession(getPrice(product.prices, currency, interval) )">{{ $t('messages.chooseplan') }}</button>
                    </div>
                    <template v-if="showFeatures">
                      <div v-if="getProductLabel(product.id).marketingFeatures.length" class="border-top border-bottom border-primary text-primary bg-light text-center pt-2 pb-2">
                        <ul class="list-unstyled m-0">
                          <li v-for="(feature, index) in getProductLabel(product.id).marketingFeatures" :key="feature" :class="{ 'fw-bold': index === 0 }">
                            {{ $t(feature) }}
                          </li>
                        </ul>
                      </div>
                      <ul  class="list-unstyled d-block mt-2 mb-0 mx-auto fs-sm" style="max-width: 16rem;">
                        <li v-for="feature in getProductLabel(product.id).features" :key="feature.text" class="d-flex py-0 align-items-center">
                          <!--<i :class="['bi', feature.enabled ? 'bi-check text-success' : 'bi-x text-danger', 'ps-3 pe-1 fs-3']"></i>-->
                          <span :class="{ 'text-muted': !feature.enabled }">✔ {{ $t(feature.text) }}</span>
                        </li>
                      </ul>
                    </template>
                  </div>
                </div>
              </div>
            </div>



          </div>
       <!--
        <div class="settings-switcher mb-3 text-center">
            <div class="mt-2 row justify-content-center">
              <div class="col-2">
                <label for="subscription-dropdown">Test sub:</label>
                <select id="subscription-dropdown" v-model="customerInfo">
                  <option v-for="item in testsubscriptions" :key="item.label" :value="item">
                    {{ item.label }}
                  </option>
                </select>
              </div>

              <div class="form-check col-1">
                <input class="form-check-input" type="checkbox" id="showFeatures" v-model="showFeatures" />
                <label class="form-check-label" for="showFeatures">Show features</label>
              </div>

              <div class="col-2">
                <a class="btn btn-primary btn-sm monthly" @click="sessionId=null">Clear session</a>
                <a class="btn btn-primary btn-sm monthly" @click="sessionId='fakesession'">Create session</a>
              </div>
              <div class="col-2">
                  <label for="currency-dropdown">Currency: </label>
                  <select v-model="currency" @change="updateCurrency(currency)" id="currency-dropdown">
                    <option value="usd">USD</option>
                    <option value="eur">EUR</option>
                    <option value="gbp">GBP</option>
                  </select>
              </div>
              <div class="col-2">
                  <label for="currency-dropdown">Language: </label>
                  <select v-model="currentLanguage" @change="setLanguage(currentLanguage)" id="currency-dropdown">
                    <option value="en">EN</option>
                    <option value="de">DE</option>
                  </select>
              </div>
            </div>
          </div>
          -->
      </div>



    <!-- STRIPE OPENING Modal -->
 
    </div>
   
  </template>
  <script setup>
  import { i18Utils } from "@/visualcrossing-core/i18utils";
  </script>
  <script>
  import pricingData from '@/data/pricingData.js';
  import testsubscriptionssource from '@/data/testsubscriptions.js';

  import productDescriptors from '@/data/productDescriptors.js';
  import translations from '@/translations/pricingComponent.js';
  import {VcDateUtils} from "/src/visualcrossing-core/vcdateutils";
  import SignUp from './SignUp.vue';


  export default {
    i18n: {
      messages: translations,
    },
    props: {
      parentCustomerInfo:Object,
      isChild:Boolean,
      showFeatures:{
        type: Boolean,
        default: true
      },
      showCurrentSubs:{
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        interval: 'month',
        currentLanguage: 'en',
        currency:'usd',
        
        customerInfo:this.parentCustomerInfo,

        noAdminPermissions:true,
        sessionId:null,
        isLoading:false,
        errorStatus:null,
        showSignup:false,
        isContainerInited:false,
        isTestMode:false,
        testsubscriptions:testsubscriptionssource,
        expandedFeatures: new Set(), // track expanded product ids
      };
    },
    computed: {
      filteredPrimaryProducts() {
        return pricingData.primary.filter((product) =>
          product.prices.some((price) => price.currency === this.currency && price.interval === this.interval)
        );
      },
      filteredPrimaryLLxProducts() {
        return pricingData.primaryllx.filter((product) =>
          product.prices.some((price) => price.currency === this.currency && price.interval === this.interval)
        );
      },
      filteredAddonProducts() {
        return pricingData.addon.filter((product) =>
          product.prices.some((price) => price.currency === this.currency && price.interval === this.interval)
        );
      },
      hasPrimarySubscription() {
        let me=this;
        return  me.primarySubscriptions && me.primarySubscriptions.length>0;
      },

      hasAddonSubscription() {
        let me=this;
        return  me.addonSubscriptions && me.addonSubscriptions.length>0;
      },
      hasOtherSubscription() {
        let me=this;
        return  me.otherSubscriptions && me.otherSubscriptions.length>0;
      },
      hasScheduledSubscription() {
        let me=this;
        return me.scheduledSubscriptions && me.scheduledSubscriptions.length>0;
      },
      primarySubscription() {
        let me=this;

        if (!me.primarySubscriptions || !me.primarySubscriptions.length) return null;
        
        return me.primarySubscriptions[0];

      },
      addonSubscription() {
        let me=this;

        if (!me.addonSubscriptions || !me.addonSubscriptions.length) return null;
        
        return me.addonSubscriptions[0];

      },
      otherSubscription() {
        let me=this;

        if (!me.otherSubscriptions || !me.otherSubscriptions.length) return null;
        
        return me.otherSubscriptions[0];

      },
      primarySubscriptions() {
        let me=this;
        if (!me.subscriptions || !me.subscriptions.length) return null;

        let primarySubscriptions=me.subscriptions.filter(d=>  {

            if (d && d.productId==="prod_EoSlQDjNxZJA0o") {
              return true;
            }
            if (d && d.product) {
              return d.product.isPrimary;
            }
            console.log("Fall thru to product list");
            /*
            if (d && d.planId) {
              const productPrice=me.getProductAndPriceByPriceId(d.planId);
              d.productPrice=productPrice;

              return productPrice && productPrice.product.isPrimary;
            }
              */
            return false;
          });
        return primarySubscriptions.length && primarySubscriptions;
      },
      addonSubscriptions() {
        let me=this;
        if (!me.subscriptions || !me.subscriptions.length) return null;

        let addonSubscriptions=me.subscriptions.filter(d=>  {
            if (d && d.product) {
              return d.product.isAddon;
            }
            console.log("Fall thru to product list");
            /*
            if (d && d.planId) {
              const productPrice=me.getProductAndPriceByPriceId(d.planId);
              d.productPrice=productPrice;

              return productPrice && productPrice.product.isAddon;
            }
              */
            return false;
          });
        return addonSubscriptions.length && addonSubscriptions;
      },
      otherSubscriptions() {
        let me=this;
        if (!me.subscriptions || !me.subscriptions.length) return null;
        let otherSubscriptions=me.subscriptions.filter(d=>  {
          if (d && d.productId==="prod_EoSlQDjNxZJA0o") {
              return false;
            }
            if (d && d.product) {
              return  !d.product.isPrimary && !d.product.isAddon;
            }
            console.log("Fall thru to product list");

            return false;
          });
        return otherSubscriptions.length && otherSubscriptions;
      },

      subscriptions() {
        var me=this;
        var subs=me.customerInfo && me.customerInfo.subscriptions;
        if (!subs || !subs.length) return [];
        return subs;
      },
      activePlans() {
        var me=this;
        var plans=me.customerInfo && me.customerInfo.plans;
        if (!plans || !plans.length) return [];
        return plans.filter(p => p && p.toLowerCase() !== 'free');
      },
      hasActivePlans() {
        return this.activePlans && this.activePlans.length > 0;
      },
      /*
      scheduledSubscriptions() {
        var me=this;
        var subs=me.customerInfo && me.customerInfo.scheduledSubscriptions;
        if (!subs || !subs.length) return [];
        return subs;
      },*/
      scheduledSubscriptions() {
        const me = this;
        const subs = me.customerInfo && me.customerInfo.scheduledSubscriptions;
        if (!subs || !subs.length) return [];
        return subs.filter(sub => (me.filteredPhases(sub) || []).length > 0);
      },
    

      hasSession() {
        return this.sessionId!=null;
      }
    },
    methods: {
      toggleFeatures(id) {
        if (this.expandedFeatures.has(id)) this.expandedFeatures.delete(id);
        else this.expandedFeatures.add(id);
      },
      isExpanded(id) {
        return this.expandedFeatures.has(id);
      },
      shortMarketing(list) {
        return list.slice(0, 1); // show first headline item
      },
      countHighlightedFeatures(list = []) {
        return list.filter(f => f && (f.highlight === true)).length;
      },
      shortFeatures(list) {
         const count = this.countHighlightedFeatures(list);
         return list.slice(0, count);
      },
      scrollToSection(id) {
        const el = document.getElementById(id);
        if (!el) return;

        const sticky = document.querySelector('.sticky-top');
        const fixedNav = document.querySelector('.navbar.fixed-top, .fixed-top');
        const stickyH = sticky ? sticky.offsetHeight : 0;
        const fixedH = fixedNav ? fixedNav.offsetHeight : 0;

        const y = el.getBoundingClientRect().top + window.pageYOffset;
        const offset = stickyH + fixedH + 8; // small gap

        window.scrollTo({ top: y - offset, behavior: 'smooth' });
      },
      addSubscriptionSchedule(subscription) {
        let me=this;
        if (!subscription || !subscription.schedule || !me.customerInfo.scheduledSubscriptions) return;

        let schedule=me.customerInfo.scheduledSubscriptions.filter (d=> {
          return d.id===subscription.schedule;
        });

        if (!schedule || !schedule.length) return;

        const now=new Date().getTime()/1000;
        let currentPhases= schedule[0].phases.filter( (phase) => phase.startsAt<now);
        if (currentPhases && currentPhases.length) {
          subscription.endsAt=currentPhases[0].endsAt;
        }

      },  
      openLink(product) {
        if (!product || !product.link) return;
        window.open(product.link, "_blank");
      },
      signupFree() {
        i18Utils.redirectTo("sign-up");
        //window.location="/sign-up/";
      },  
      contactUs(product) {
        let productLabel = product && productDescriptors[product.id] && productDescriptors[product.id].name;
        productLabel = productLabel && this.$t(productLabel);
        
        // URL encode the product label to handle special characters, spaces, etc.
        const encodedSubject = encodeURIComponent(`Interest in ${productLabel}`);
        
        window.location = `/support/new-ticket/?type=Business+Enquiry&subject=${encodedSubject}`;
      }, 
      contactSupport(product) {
        let productLabel= product && productDescriptors[product.id] && productDescriptors[product.id].name;
        productLabel = productLabel && this.$t(productLabel);
        i18Utils.redirectTo("support");
        //window.location="/support/";
      },  
      filteredPhases(sub) {
        let me=this;
        if (!sub || !sub.phases) return null;
        const now=new Date().getTime()/1000;
        return sub.phases.filter( (phase) => phase.startsAt>now);
      },
      getSubLabel(sub) {
        let me=this;
        if (!sub) return "-";
        if (sub.usageType==="metered") return sub.product.name+" - metered";
        return sub.product.name+(sub.interval?" - "+sub.interval:"");
      },  
      getSubStatus(sub) {
        if (!sub || !sub.status) return "-";

        switch (sub.status) {
          case "incomplete":
            return "Incomplete (pending first payment)";
          case "incomplete_expired":
            return "Expired (setup not completed)";
          case "trialing":
            return "Trialing";
          case "active":
            return "Active";
          case "past_due":
            return "Past Due (payment issue)";
          case "canceled":
            return "Canceled";
          case "unpaid":
            return "Unpaid (no further payment attempts)";
          case "paused":
            return "Paused";
          default:
            return sub.status.charAt(0).toUpperCase() + sub.status.slice(1);
        }
      },

      isSubActive(sub) {
        if (!sub || !sub.status) return false;

        // Stripe considers these states as “active” for continued access
        switch (sub.status) {
          case "active":
          case "trialing":
          //case "past_due": // optional, depending on your business logic
            return true;
          default:
            return false;
        }
      },
      canModifySub(sub) {
        let me=this;
        return !me.isDirectBilled(sub) && !sub.schedule && !sub.cancelAtPeriodEnd && me.isSubActive(sub);
      },
      isDirectBilled(sub) {
        //var me=this;
       
        //console.log("isPrimaryDirectBilled not implemented");
        return sub.isDirect;
      },
      isLegacy(sub) {
        return sub.product && !sub.product.isActive;
      },
      getProductAndPriceByPriceId(priceId) {
        if (!pricingData) return null;
        const allPrices = [...pricingData.primary, ...pricingData.addon];
        for (const product of allPrices) {
          const matchingPlan = product.prices.find((price) => price.id === priceId);

          // If a matching plan is found, return both the product and the plan
          if (matchingPlan) {
            return {
              product,
              price: matchingPlan,
            };
          }
        }

        return null;
      },  
      setInterval(newInterval) {
        this.interval = newInterval;
      },
      setLanguage(lang) {
        this.currentLanguage = lang;
        this.$i18n.locale = lang;
      },
      updateCurrency(newCurrency) {
        this.currency=newCurrency;
      },
      isMeteredToLicensed(sub, products, currency, interval) {
        let me=this;
        //let sub=me.getSubFromPrices(products, currency, interval);
        if (!sub) return false;
        const price=me.getPrice(products, currency, interval);
        if (!sub || sub.schedule) return false;
        if (sub.usageType==="metered" && price.usageType==="licensed") return true;

        return false;

      },
      isLicensedToMetered(sub, products, currency, interval) {
        let me=this;
        //let sub=me.getSubFromPrices(products, currency, interval);
        if (!sub || sub.schedule) return false;
        const price=me.getPrice(products, currency, interval);

        if (sub.usageType==="licensed" && price.usageType==="metered") return true;

        return false;

      },
      canUpgradeToPrice(sub, products, currency, interval) {
        let me=this;
        //let sub=me.getSubFromPrices(products, currency, interval);
        if (!sub || sub.schedule) return false;
        const price=me.getPrice(products, currency, interval);
      

        if (sub.interval==="year" && sub!=="year") return false;
        //if (.usageType!==price.usageType) return false;
        if (sub.usageType==="metered" && price.usageType!=="metered") return true;
        if (sub.amount/100>price.amount) return false;

        return true;

      },
      canDowngradeToPrice(sub, products, currency, interval) {
        let me=this;
        //let sub=me.getSubFromPrices(products, currency, interval);
        if (!sub|| sub.schedule) return false;
        const price=me.getPrice(products, currency, interval);
       
       // if (.interval==="year" && interval!=="year") return false;
        if (sub.usageType!==price.usageType) return false;
        if (sub.amount<price.amount) return false;
        
        return true;
      },
      getSubFromPrices(prices, currency, interval) {
        let me=this;
        return me.isPriceActiveSub(null, prices, currency, interval);
      },
      isPriceCancellingSub(subscriptionOrSubscriptions, prices, currency, interval) {
        let me=this;
        const sub=me.isPriceActiveSub(subscriptionOrSubscriptions, prices, currency, interval);
        return me.getSubCancelAtPeriodEnd(sub);
      },
      isPriceActiveSub(subscriptionOrSubscriptions, prices, currency, interval) {
        let me=this;
        if (!subscriptionOrSubscriptions) subscriptionOrSubscriptions=me.subscriptions;
        if (subscriptionOrSubscriptions.length>0) {
          for (const subscription of subscriptionOrSubscriptions) {
              const foundSub=me.isPriceActiveSub(subscription, prices, currency, interval);
              if (foundSub) return foundSub;
          }
          return false;
        }

        const subscription=subscriptionOrSubscriptions;

        const price=me.getPrice(prices, currency, interval);
        return price && price.id==subscription.planId && subscription;
      },

      isPriceContactUs(product) {
        const price = this.getPrice(product.prices, this.currency, this.interval);
        return product.isContactUs || (price && price.label === 'contactus');
      },
      getPrice(prices, currency, interval) {
        if (!prices ||!prices.find) {
          console.log("Danger")
        }
        const price = prices.find((p) => p.currency === currency && p.interval === interval);
        return price;
        //return price ? price.amount : 'N/A';
      },
      getPriceAmount(prices, currency, interval) {
        const price=this.getPrice(prices, currency, interval);
        if (!price) return "-";
        if (price.label) {
          return this.$t("messages."+price.label);
        }
        return price.amount;
      },
      showCurrency(prices, currency, interval) {
        const price=this.getPrice(prices, currency, interval);
        return price && price.amount>0;
      },
      showInterval(prices, currency, interval) {
        const price=this.getPrice(prices, currency, interval);
        return price && price.amount>0;
      },
      getPricesByIntervalAndCurrency(product, interval, currency) {
        const matchingPrices = [];

          // Filter prices in the current product that match the interval and currency
          return product.prices.filter(
            (price) => price.interval === interval && price.currency === currency
          );


      },
      getPriceInterval(product, currency, interval) {
        if (product.interval) return this.$t(product.interval);
        return this.$t(interval);
        //const price = product.prices.find((p) => p.currency === currency && p.interval === interval);
        //return interval;
      },
      getProductLabel(productId) {
        
        const retVal= productId && productDescriptors[productId];
        if (!retVal) {
          console.error(`No product descriptor found for '${productId}'`);
          return {
            name: 'descriptions.badName',
            description: 'descriptions.badDescription',
            marketingFeatures: [],
            features: [],
          }
        }
       // console.log(`${productId} - ${retVal.name}`);
        return retVal;
      },
      getIconPath(product) {
        //return new URL(`@/assets/icons/pricelist/${product.icon}`, import.meta.url).href;
        let icon=product.icon || `icon-${product.name.toLowerCase()}.svg`;

        return `${import.meta.env.VITE_PUBLIC_ASSET_URL}icons/pricelist/${icon}`;
      },
      isSubMeteredNoPaymentMethod(sub) {
        let me=this;

        return me.isSubMetered(sub) && !me.hasPaymentMethod;
      },
      isSubMetered(sub) {
        let me=this;
        return sub && sub.plan && sub.plan.usageType==='metered';
      },
      getSubCancelAtPeriodEnd:function(sub) {
        return sub && sub.cancelAtPeriodEnd;
      },
     
      getSubRenewalDate(sub) {
        var date=sub && new Date(sub.currentPeriodEnd)
        if (!date) return "-";
        return VcDateUtils.formatDate(date);
      },
      getSubStartDate(sub) {
        var date=sub && sub.startsAt && new Date(sub.startsAt*1000)
        if (!date) return "-";
        return VcDateUtils.formatDate(date);
      },
      getSubEndsDate(sub) {
        var date=sub && sub.endsAt && new Date(sub.endsAt*1000)
        if (!date) return "-";
        return VcDateUtils.formatDate(date);
      },
      getBillingIntervalDesc(plan) {
        var me=this;
        if (!plan || !plan.interval) return "-";
        if (plan.interval==="month") return "Monthly";
        if (plan.interval==="year") return "Annually";
        return "-"
      },
       /*
      getProductPlanName(plan) {
        var me=this;
        if (!plan) return "-";
        let product=this.getProductFromPlan(plan);
        let name=product && product.name;
        let isActive=product && product.isActive;

        if (!name) name="Product?";
        
        if (plan.name) {
          name= name+" "+plan.name;
        }

        if (plan.usageType==="metered") {
          //noop;
        } else {
          let billingInterval=me.getBillingIntervalDesc(plan);

          if (billingInterval) {
            name= name+" - "+billingInterval;
          }
        }


        if (!isActive) name=name+" *";
        

        return name;


      },
     
      getPlan(planId) {
        var me=this;
        var products=me.customerInfo && me.customerInfo.products;
        if (!products) return null;
        return products.reduce(function (a, d) {
          if (a || !d || !d.plans) return a;
          return d.plans.reduce(function(b,e) {
            if (b ) return b;
            return (e && e.id===planId && e) || null;
          }, a)
        }, null);
      },
      getProductFromPlan(plan) {
        let me=this;
        let products=me.customerInfo && me.customerInfo.products;
        if (!products) return null;
        return products.reduce(function (a, d) {
          if (a || !d || !d.plans) return a;
          if (d.plans.indexOf(plan)!==-1) return d;
          return a;
        }, null);
      },
      */
      refreshCustomerInfo() {
        let me=this;
        if (me.isTestMode && me.customerInfo) return;
        if (me.isChild) {
          me.noAdminPermissions=!me.customerInfo;
          return;
        }
        me.customerInfo=null;
       
        if (!me.hasSession) return;

        me.isLoading=true;
        vcCommunicator.refreshCustomerInfo(false)
          .then(function (result) {
            me.isLoading=false;
            me.errorStatus=null;
            me.customerInfo=result;
            me.noAdminPermissions=false;
            const primarySubscriptionInterval=me.primarySubscription && me.primarySubscription.interval;
            me.addSubscriptionSchedule(me.primarySubscription);

            if (primarySubscriptionInterval) {
             
              if (primarySubscriptionInterval!=me.interval) {
                me.setInterval(primarySubscriptionInterval);
              }
            }

          }).catch((error) => {
            me.isLoading=false;
            if (error && error.indexOf("administrative permissions")) {
              me.noAdminPermissions=true;
            } else {
              me.errorStatus="There was a problem loading the information. <br/>"+error;
              me.noAdminPermissions=false;
            }
          
          });
      },
      createSessionThenCheckout(plan) {
        var me=this;
        let planId=plan.id
        me.showSignup=true;
        
        if (typeof window.gtag === "function") {
            gtag('event', 'create_session_checkout', {  // Custom event name
                item_id: planId,  // Custom parameter
                item_name: plan.name,
                price: plan.amount,
                currency: 'USD'
            });
        }

        vcCommunicator.addHandler('createsession', function (sessionId,sessionState) {
          me.sessionId=sessionId;
          me.sessionState=sessionState;
          me.isContainerInited=true;
         
          me.createCheckoutSession(plan);
        });

      },

      createCheckoutSession:function(plan) {
        var me=this;
        let planId=plan.id;

        
        if (typeof window.gtag === "function") {
            gtag('event', 'begin_checkout', {
                currency: 'USD',
                value: plan.amount, // Total value of checkout
                items: [{
                    item_id: planId,
                    item_name: plan.name, // Product name
                    quantity: 1,
                    price: plan.amount
                }]
            });
        }

        if (me.isTestMode) {
          planId=planId+"|"+me.customerInfo.id;
        }
       
       
        vcCommunicator.createcheckoutsession(planId,  window.location.pathname+"?r=1",  window.location.pathname+"?r=2")
          .then(function (result) {
            me.submitted=false;
          
            window.location.href = result.url;
          }).catch((error) => {
            me.submitted=false;
            
            me.errorStatus="Error creating checkout session. <br/>"+error;
          });
      },

      createportalsession(flowType, subscriptionId, planId, id) {
        var me=this;

        if (!flowType) {
          flowType="testconfig";
        }
        //if (!id) {
        //  id=me.customerInfo.id;
       // }
        me.submitted=true;

        me.stripeLinkOpening=true;

        //me.showModal('#primaryPlanChooserModal', false);
      
        vcCommunicator.createportalsession(flowType, subscriptionId, planId, id, window.location.pathname)
          .then(function (result) {
            me.submitted=false;
            me.stripeLinkOpening=false;
            console.log("createPortalSession", result)
            window.location.href = result.url;
          }).catch((error) => {
            me.submitted=false;
            me.stripeLinkOpening=false;
            me.errorStatus="Error creating portal session. <br/>"+error;
          });
      },
    },
    mounted() {
      var me=this;
      


      var vcCommunicator=window.vcCommunicator;
      if (!vcCommunicator) {
        console.log("No vcCommunicator");
        return;
      }

      if (me.isTestMode) {
        me.customerInfo=testsubscriptionssource[0];
      }
    
      me.sessionId=vcCommunicator.sessionId;
      me.sessionState=vcCommunicator.sessionState;
      me.isContainerInited=vcCommunicator.isInited || me.sessionId;
      vcCommunicator.addHandler('createsession', function (sessionId,sessionState) {
        me.sessionId=sessionId;
        me.sessionState=sessionState;
        me.isContainerInited=true;
        console.log("Session updated..."+me.showSignup);
        me.showSignup=false;
        me.refreshCustomerInfo();
      });
      vcCommunicator.addHandler('createsessionfailed', function (sessionId,sessionState) {
        me.sessionId=null;
        me.sessionState=null;

        me.isContainerInited=true;
      
      });
      vcCommunicator.addHandler('terminatesession', function () {
        me.sessionId=null;
        me.customerInfo=null;
      });

    // me.mountStripe();
      
      me.refreshCustomerInfo();

      /*
      let checkoutSessionId=VcUtils.qs["session_id"] || null;
      if (checkoutSessionId) {
        me.processCheckoutSession(checkoutSessionId);
      }*/
    },
    components: {
      SignUp
    }
  };
  </script>
  
<style scoped>
.pricing-chip {
  transition: transform .05s ease, box-shadow .15s ease;
}
.pricing-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 .25rem .5rem rgba(0,0,0,.08);
}
.pricing-chip:focus {
  box-shadow: 0 0 0 .2rem rgba(255,255,255,.35);
}
#availableprimarysubs,
#availableprimaryllxsubs,
#availableaddonsubs {
  scroll-margin-top: var(--pricing-sticky-offset, 88px);
}

.start-90 { 
  left: 90% !important; 
}
</style>
  